'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfiniteScroll = function (_React$Component) {
  (0, _inherits3.default)(InfiniteScroll, _React$Component);

  function InfiniteScroll(props) {
    (0, _classCallCheck3.default)(this, InfiniteScroll);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InfiniteScroll.__proto__ || (0, _getPrototypeOf2.default)(InfiniteScroll)).call(this, props));

    _this.state = {
      invoked: 0
    };

    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.unpause = _this.unpause.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      document.addEventListener('scroll', this.handleScroll);
      var start = Date.now();

      var loadedPastVisible = void 0;

      var load = function load() {
        loadedPastVisible = _this2.loadIfVisible();
        if (!loadedPastVisible && Date.now() - start < 500) {
          setTimeout(load, 10);
        }
      };
      load();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'setWrapperRef',
    value: function setWrapperRef(node) {
      this.wrapperRef = node;
    }
  }, {
    key: 'loadIfVisible',
    value: function loadIfVisible() {
      if (this.wrapperRef) {
        var _props = this.props,
            action = _props.action,
            finished = _props.finished;

        var rect = this.wrapperRef.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        if (typeof global.window !== 'undefined') {
          // Only completely visible elements return true:
          var isVisible = elemTop >= 0 && elemBottom <= global.window.innerHeight;
          if (!this.isPaused() && isVisible && !finished) {
            this.setState({
              invoked: this.state.invoked + 1
            }, action);
            return true;
          } else if (!this.isPaused() && !isVisible) {
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: 'isPaused',
    value: function isPaused() {
      var messageAfter = this.props.messageAfter;
      var invoked = this.state.invoked;

      return messageAfter !== undefined && messageAfter !== -1 && invoked >= messageAfter;
    }
  }, {
    key: 'unpause',
    value: function unpause() {
      var action = this.props.action;

      this.setState({
        invoked: 0
      }, action);
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var _props2 = this.props,
          action = _props2.action,
          finished = _props2.finished;

      var rect = this.wrapperRef.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      if (typeof global.window !== 'undefined') {
        // Only completely visible elements return true:
        var isVisible = elemTop >= 0 && elemBottom <= global.window.innerHeight;
        if (!this.isPaused() && isVisible && !finished) {
          this.setState({
            invoked: this.state.invoked + 1
          }, action);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          message = _props3.message,
          className = _props3.className,
          finished = _props3.finished;

      return _react2.default.createElement(
        'div',
        { className: className, ref: this.setWrapperRef },
        this.isPaused() && !finished && _react2.default.createElement(
          'button',
          { className: 'InfiniteScroll_button', onClick: this.unpause },
          message
        )
      );
    }
  }]);
  return InfiniteScroll;
}(_react2.default.Component);

InfiniteScroll.propTypes = {
  action: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  message: _propTypes2.default.string,
  finished: _propTypes2.default.bool.isRequired,
  /** Load more message after number of invokes, provide -1 for infinite invokes */
  messageAfter: _propTypes2.default.number
};

InfiniteScroll.defaultProps = {
  className: undefined,
  message: 'Load More...',
  messageAfter: undefined
};

exports.default = InfiniteScroll;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/InfiniteScroll.js
// module id = 1150
// module chunks = 0